export enum PartnershipInvitationType {
  CLIENT = 'client',
  MEMBER = 'member',
  EMPLOYEE = 'employee',
  PUBLIC = 'public',
  RETIRED_EMPLOYEE = 'retired_employee',
  FORMER_MEMBER = 'former_member',
  REFERRAL_PROGRAM = 'referral_program'
}
